import React from 'react';
import { Dropdown } from 'react-bootstrap';

import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import useLocalStore from 'src/store/useLocalStore';

import { Language } from 'src/models/Language.model';

import useUiTranslation from 'src/hooks/useUiTranslation';

type UiLanguageDropdownProps = {
  className?: string;
};

const UiLanguageDropdown = ({ className }: UiLanguageDropdownProps) => {
  const { tCommon, language, changeLanguage } = useUiTranslation();

  const { setUiLanguage } = useLocalStore();

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="link"
        className={classNames(
          'text-decoration-none text-primary p-0',
          className,
        )}
      >
        <FontAwesomeIcon icon={faLanguage} className="me-2" />

        {tCommon(`report.languageEnum.${language}`)}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {Object.values(Language).map((lang) => (
          <Dropdown.Item
            key={lang}
            active={language === lang}
            onClick={async () => {
              await changeLanguage(lang);
              setUiLanguage(lang);
            }}
          >
            {tCommon(`report.languageEnum.${lang}`)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UiLanguageDropdown;
